// extracted by mini-css-extract-plugin
export default {"swiperStyle":"TitleSwiper_swiperStyle__DKRZk","imgStyle":"TitleSwiper_imgStyle__c5Iyz","cardStyles":"TitleSwiper_cardStyles__SkKCY"};